import { helper } from '@ember/component/helper';
import pluralize from 'cio/utils/pluralize';
import { formatNumber } from '../format-number';
import { formatNumberAndPluralize } from '../format-number-and-pluralize';
import ImportModel from 'cio/models/import';
import { getImportTargetData } from 'cio/utils/imports';

const createMessage = ({
  type,
  count,
  importTarget,
  totalCount = 0,
  isImportingType,
  isProfilesImport,
}: {
  type: 'new' | 'existing';
  count: number;
  importTarget: string;
  totalCount?: number;
  isImportingType: boolean;
  isProfilesImport: boolean;
}) => {
  let message = [];

  if (!isProfilesImport) {
    return `${formatNumberAndPluralize([totalCount, 'row'])} in your file ${pluralize(
      totalCount,
      'has a',
      'have',
    )} ${type} ${pluralize(totalCount, `identifier`)}. These rows when imported will create ${formatNumberAndPluralize([
      count,
      `new person`,
    ])}.`;
  }

  message.push(
    `${formatNumber([count])} of ${formatNumberAndPluralize([
      totalCount,
      'row',
    ])} in your file were identified as ${type} and without errors.`,
  );

  if (count && isImportingType) {
    let result;

    if (type === 'new') {
      result = `create ${formatNumber([count])} new`;
    }

    if (type === 'existing') {
      result = `update ${formatNumber([count])} existing`;
    }

    message.push(
      `${pluralize(count, 'This row', 'These rows')} will be imported to ${result} ${pluralize(count, importTarget)}.`,
    );
  } else if (count) {
    message.push(
      `These will not be imported since you selected to ${
        type === 'new' ? 'update existing' : 'import new'
      } ${pluralize(2, importTarget)} only.`,
    );
  }

  return message.join(' ');
};

export function importDetailTooltipText([record, type]: [ImportModel, 'new' | 'existing']) {
  let { validateMeta, isProfilesImport } = record;
  let importTargetData = getImportTargetData(record);

  if (type === 'new') {
    return createMessage({
      type,
      count: importTargetData.newProfiles ?? 0,
      importTarget: importTargetData.target,
      totalCount: validateMeta?.rows,
      isImportingType: record.importNew,
      isProfilesImport,
    });
  }

  // if not new, type will be 'existing'
  return createMessage({
    type,
    count: importTargetData.existingProfiles ?? 0,
    importTarget: importTargetData.target,
    totalCount: validateMeta?.rows,
    isImportingType: record.importExisting,
    isProfilesImport,
  });
}

export default helper(importDetailTooltipText);
